import { useState } from "react";
import { Euro, eur, txt, fmt, Toggle, Field, Note, InputCard, ResultCard } from "./shared";
import { useLang } from "@/lib/i18n";

const CORP_TAX = 0.1;
const DIV_TAX = 0.05;

export const DividendCalc = () => {
  const [mode, setMode] = useState("pre");
  const [amount, setAmount] = useState("10000");
  const { t } = useLang();
  const s = t.calc.dividend;
  const num = parseFloat(amount.replace(",", ".")) || 0;

  const preTax = mode === "pre" ? num : num / (1 - CORP_TAX);
  const corpTax = preTax * CORP_TAX;
  const distributable = preTax - corpTax;
  const divTax = distributable * DIV_TAX;
  const net = distributable - divTax;
  const effective = preTax > 0 ? ((preTax - net) / preTax) * 100 : 0;

  const rows = [
    { label: s.rows.pretax, ...eur(preTax), testid: "div-row-pretax" },
    { label: s.rows.corp, ...eur(corpTax), testid: "div-row-corp-tax" },
    { label: s.rows.dist, ...eur(distributable), testid: "div-row-distributable" },
    { label: s.rows.div, ...eur(divTax), testid: "div-row-div-tax" },
    { label: s.rows.eff, ...txt(`${effective.toFixed(2).replace(".", ",")} %`), testid: "div-row-effective" },
  ];

  return (
    <>
      <InputCard kicker={s.kicker}>
        <Toggle
          testidPrefix="div-mode"
          value={mode}
          onChange={setMode}
          options={[
            { id: "pre", label: s.pre },
            { id: "post", label: s.post },
          ]}
        />
        <Field id="div-amount" testid="div-amount-input" label={mode === "pre" ? s.preLabel : s.postLabel} value={amount} onChange={setAmount} />
        <Note>{s.note}</Note>
      </InputCard>
      <ResultCard title={s.title} service={s.service} note={s.note} label={s.result} main={<Euro value={net} />} mainText={`${fmt(net)} €`} rows={rows} />
    </>
  );
};
